/**
 * @module @shared/config/env
 * Typsichere Vite-Env mit sinnvollen Defaults. Alle Werte dürfen Platzhalter
 * sein — die App MUSS auch ohne echtes Backend rendern (kein Crash bei
 * fehlender Env). Echte Validierung der Daten passiert an den API-Boundaries.
 */

/** Liest eine `VITE_*`-Variable und fällt auf den Default zurück. */
function read(key: keyof ImportMetaEnv, fallback: string): string {
  const value = import.meta.env[key];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

/** Optionaler Env-Wert (leerer String → `undefined`). */
function readOptional(key: keyof ImportMetaEnv): string | undefined {
  const value = import.meta.env[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * Zentrale, aufgelöste Umgebungs-Konfiguration der Login-App.
 * Defaults zielen auf die ATRIUM-Marke und das zentrale `gmolike-id`-Projekt.
 */
export const env = {
  /** URL des zentralen Auth-Projekts (`gmolike-id`). Platzhalter ist erlaubt. */
  supabaseUrl: read('VITE_SUPABASE_URL', 'https://gmolike-id.supabase.co'),
  /** Publishable Key (`sb_publishable_…`) — client-safe. */
  publishableKey: read('VITE_SUPABASE_PUBLISHABLE_KEY', 'sb_publishable_placeholder'),
  /** Default-App-Slug, wenn keiner per `?app=` übergeben wird. */
  appSlug: read('VITE_APP_SLUG', 'atrium'),
  /** Basis-URL der zentralen Login-App. */
  loginUrl: read('VITE_LOGIN_URL', 'https://auth.gmolike.me'),
  /** Cookie-Domain für Cross-Subdomain-SSO (lokal i. d. R. leer lassen). */
  cookieDomain: readOptional('VITE_COOKIE_DOMAIN'),
} as const;

/** Aufgelöste Env-Konfiguration der Login-App. */
export type Env = typeof env;
